import { api } from './api';

export interface ResultUser {
  _id: string;
  name: string;
  email: string;
}

export interface ResultData {
  id?: string;
  _id?: string;
  userId?: ResultUser | string;
  result: string;
  additionalData?: any;
  createdAt?: string;
  conversationId?: string;
  v?: number;
  _v?: number;
}

export const resultService = {
  async getResults(filterOptions: { 
    onlyCurrentUser?: boolean; 
    userProfile?: string;
    organizationId?: string;
  } = {}): Promise<ResultData[]> {
    const token = localStorage.getItem('@App:token');
    const userStr = localStorage.getItem('@App:user');
    const user = userStr ? JSON.parse(userStr) : {};
    
    let url = '/api/result';
    
    // Verificar o perfil do usuário e usar a rota adequada
    if (user?.profile) {
      const userProfile = user.profile.toLowerCase();
      const organizationId = filterOptions.organizationId || 
                            (user.organizationId && user.organizationId[0] ? user.organizationId[0] : '');
      
      if (organizationId) {
        if (userProfile === 'user') {
          // Para usuários comuns, usar a rota específica por usuário
          url = `/api/result/organization/${organizationId}/user/${user.id}`;
        } 
        else if (userProfile === 'manager') {
          // Para managers e admins, usar a rota por organização
          url = `/api/result/organization/${organizationId}/user/${user.id}`;
        }
        else if (userProfile === 'admin') {
          // Para managers e admins, usar a rota por organização
          url = `/api/result/organization/${organizationId}/user/${user.id}`;
        }
        // else if (userProfile === 'manager') {
        //   // Para managers e admins, usar a rota por organização
        //   url = `/api/result/organization/${organizationId}`;
        // }
        // else if (userProfile === 'admin') {
        //   // Para managers e admins, usar a rota por organização
        //   url = `/api/result`;
        // }
      }
    }
    
    const response = await api.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  async saveResult(result: string, additionalData?: any): Promise<ResultData> {
    const token = localStorage.getItem('@App:token');
    const userStr = localStorage.getItem('@App:user');
    const user = userStr ? JSON.parse(userStr) : {};
    
    // Criar objeto de dados com o resultado e dados adicionais, se fornecidos
    const data = {
      result,
      idOrganization: user.organizationId ? user.organizationId[0] : '',
      ...(additionalData && { additionalData })
    };
    
    console.log('Enviando dados:', data); // Log para debug
    
    const response = await api.post('/api/result', 
      data,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  }
}; 